<template>
    <div class="paymethod-list-dom" v-loading="loading">
        <transportRecord v-for="(v, i) in transportList" :key="v.ID" :obj="v" @clickDelete="clickDelete" @clickEdit="clickEdit" />

        <el-empty :description="i18n.tkey('lang_temporary_no_data')" v-show="transportList.length == 0">
            <el-button type="primary" @click="clickInsert" tkey="添加">{{i18n.tkey('lang_add')}}</el-button>
        </el-empty>
    </div>
</template>

<script setup>
    import transportRecord from "@/components/shopopee/material/transportRecord"
    import {toRef, ref, onMounted, inject} from "vue";
    import eshopopeeApi from "@/request/eshopopeeApi";
    import myUtil from "@/util/util";

    const emits = defineEmits(['clickEdit', 'clickDelete', 'clickAdd'])

    const i18n = inject("i18n")

    const transportList = ref([])

    const loading = ref(false)

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return {} } })

    const shopCompany = ref({})

    function getPaymentList() {
        loading.value = true
        const request = eshopopeeApi.getDeliveryList
        const params = request.getParams()

        params.companyCode = shopCompany.value.acccompanycode

        request.send(params, getListCallback)
    }

    function getListCallback(res) {
        loading.value = false

        if (myUtil.isNotEmpty(res) && myUtil.isNotEmpty(res.detail)){
            transportList.value = res.detail
        }else{
            transportList.value = []
        }
    }

    function clickEdit(obj) {
        emits("clickEdit", obj)
    }

    function clickDelete(obj) {
        const id = obj.ID

        for (let i=0; i<transportList.value.length; i++){
            const v = transportList.value[i]

            if (v.ID == id){
                transportList.value.splice(i, 1)
                break
            }
        }

        const request = eshopopeeApi.delDelivery
        const params = request.getParams()
        params.companyCode = shopCompany.value.acccompanycode
        params.ProductID = obj.ProductID

        request.send(params, (res) => {

        })

        myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
    }

    function clickInsert(){
        emits("clickAdd")
    }

    onMounted(() => {
        shopCompany.value = getShopCompanyObj()

        getPaymentList()
    })

</script>

<style scoped>
    .paymethod-list-dom {
        margin: 0;
        list-style: none;
        min-height: 300px;
        padding-top: 20px;
        padding-left: 0;
    }
</style>